import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { getCompanyWorkerLogs } from 'api/worker'
import { useAuthContext } from 'components/auth'
import { workerKeys } from './keys'

type CompanyWorkerLogs = Awaited<ReturnType<typeof getCompanyWorkerLogs>>

export function useWorkerLogs(
  query: {
    startDate: Date
    endDate: Date
    workerId: number
  },
  options: Partial<UseQueryOptions<CompanyWorkerLogs>> = {}
) {
  const { company } = useAuthContext()

  return useQuery({
    ...options,
    queryKey: workerKeys.logs(query),
    queryFn: () => {
      if (!company?.id) {
        throw new Error('Company ID not found')
      }
      return getCompanyWorkerLogs({
        companyId: company.id,
        startDate: query.startDate,
        endDate: query.endDate,
        userId: query.workerId,
      })
    },
    enabled: Boolean(company?.id) && (options.enabled ?? true),
  })
}
